import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-aura px-4 py-2 text-center" data-id="element-170" data-mp="2zb2qzvd4yfy0">
      <p className="text-[11px] font-normal leading-snug text-white sm:text-xs" data-id="element-171" data-mp="14tt0h0epalvt">
        <span className="sm:hidden" data-id="element-172" data-mp="1iqg9i1jxh2i3">
          🇦🇷 Disponible en Argentina · Pago único · Garantía de 7 días
        </span>
        <span className="hidden sm:inline" data-id="element-173" data-mp="q2k5ebs148ba">
          🇦🇷 Disponible actualmente en Argentina · Acceso digital inmediato · Pago único · Garantía
          de 7 días
        </span>
      </p>
    </div>;
}